import SuperTokens from "supertokens-auth-react";
import {
  consumeCode,
  createCode,
  resendCode,
} from "supertokens-auth-react/recipe/passwordless";
import Session from "supertokens-auth-react/recipe/session";

import { consumeCodeInput } from "../application/auth";
import { AuthService } from "../application/auth/auth.ports";
import { getApiDomain, getBaseApiPath } from "../configs";
import { SuperTokensConfig } from "../configs/supertokens";
import { Singleton } from "../utils/singleton";

class UseAuthService implements AuthService {
  constructor() {
    SuperTokens.init(SuperTokensConfig);
  }

  consumeCode = (input?: consumeCodeInput) => consumeCode(input);

  consumeLinkCode = async (linkCode: string, preAuthSessionId: string) => {
    const url = `${getApiDomain()}${getBaseApiPath()}/signinup/code/consume`;

    await fetch(url, {
      body: JSON.stringify({ linkCode, preAuthSessionId }),
      method: "POST",
    });
  };

  createCode = createCode;

  resendCode = resendCode;

  redirectToAuth = SuperTokens.redirectToAuth;

  doesSessionExist = Session.doesSessionExist;

  attemptRefreshingSession = Session.attemptRefreshingSession;

  signOut = Session.signOut;
}

// To ensure SuperTokens.init runs only once
export default Singleton(UseAuthService);
